module.exports = __webpack_public_path__ + "img/img-video.6ca1e703.png";